import loadDavinci from './loadDavinci';
import React, { useEffect } from 'react';

const CmsDavinci = ({ context }) => {
  useEffect(() => {
    loadDavinci();
  }, []);

  const davinciUrl = `https://${context}.dvinci-hr.com/jobPublication/list.json`;
  /*
    This block gets replaced by the "loadDavinci" function
  */
  return (
    <div
      aria-label="Stellenangebote"
      className="dvinci-job-widget"
      data-filter-category-label="Bereiche"
      data-filter-company-enabled="true"
      data-filter-company-hidden="true"
      data-filter-company-selected="WIEN_ENERGIE_GMBH"
      data-filter-keyword-enabled="true"
      data-filter-location-enabled="false"
      data-filter-targetgroup-label="Karrierelevel"
      data-style-brand-color="#000460"
      data-style-font-family="'Fira Sans', arial, sans-serif"
      data-style-headline-font-size="20px"
      data-style-label-font-size="20px"
      data-theme="default-cards"
      data-url={davinciUrl}
    >
      &nbsp;
    </div>
  );
};

export default CmsDavinci;
